import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToString',
  standalone: true
})
export class EnumToStringPipe implements PipeTransform {
  transform(value: number, enumObject: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    // Find the key that matches the value
    const key = Object.keys(enumObject).find(k => enumObject[k] === value);
    return key || value.toString();
  }
}
